import { Component, Input } from '@angular/core';


/**
   * Logger Factory
   * @namespace size: 
*/

@Component({
  selector: 'ute-loader',
  templateUrl: 'ute-loader.component.html'
})
export class UteLoaderComponent {

  @Input() size: string;
  @Input() title: string;
  @Input() desc: string;


  public loaded: boolean;

  constructor() {
    
  }


}


// WEBPACK FOOTER //
// ./src/app/components/atoms/ute-loader/ute-loader.component.ts